import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { UsersComponent } from "../users/components/users/users.component";
import { SitesAreaComponent } from "../sites-area/components/sites-area/sites-area.component";
import { CompanyComponent } from "../company/components/company/company.component";
import { forkJoin } from "rxjs";
import { SitesAreaService } from "../sites-area/services/sites-area.service";
import { Organization } from "@shared/models/organization";
import { Country } from "@shared/models/country";
import { Router } from "@angular/router";
import { LocalStorageService } from "@shared/services/utilities/local-storage.service";
import { CurrentStateService } from "app/core/services/current-state.service";
import { MENU_OPTIONS } from "@shared/constants/left-menu-option";

@Component({
    standalone: true,
    selector: 'app-setting',
    templateUrl: './setting.component.html',
    styleUrls: ['./setting.component.scss'],
    imports: [CommonModule, FormsModule,MatIconModule, TranslateModule,UsersComponent, SitesAreaComponent, CompanyComponent],
})
export class SettingComponent implements OnInit {
    selectedTab: number = 1;
    selectedUserId: string = null;
    organizations : Organization[] = [];
    countries : Country[] = [];
    menuOptions = MENU_OPTIONS;
    constructor(private sitesAreaService: SitesAreaService,private router: Router,
       private localStorageService: LocalStorageService,protected currentStateService: CurrentStateService) { }

    ngOnInit(): void {
    forkJoin({
      organizations: this.sitesAreaService.getOrganisations(),
      countries: this.sitesAreaService.getCountries()
    }).subscribe(({ organizations, countries }) => {
      this.organizations = organizations;
      this.countries = countries;
      this.sitesAreaService.setCountries(countries);
    });

    }
    changeMenu(tabNumber: number): void {
        this.selectedTab = tabNumber;
    }
    closeSettings() {
      this.router.navigate(['/']);
      this.currentStateService.setCurrentMenu(this.menuOptions.CONTROL_POINT);
      this.localStorageService.setItem('currentMenu', this.menuOptions.CONTROL_POINT);
      }
      onUserSelected(userId: string) {
        this.selectedUserId = userId;
        this.selectedTab = 2;
        
      }

}